// 试题回顾
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
// import { Dialog } from 'vant'
import { getReview } from '@/api/index'
import { getQueryString, } from '@/utils/tools'

export const useCommonReviewQuesEffect = () => {
  const router = useRouter()
  const store = useStore()
  const questionActiveKey = getQueryString('questionActiveKey')
  const resultType = parseInt(getQueryString('resultType'))
  const answerGroupKey = getQueryString('answerGroupKey')
  const isStudy = getQueryString('isStudy')

  // 区分模拟考试还是正式考试来显示不显示正确答案
  let type = 1
  // 考试练习
  if (resultType === 2 || isStudy) {
    type = 2
  } else {
    type = store.getters.getQuesSetting?.answerShow || 1
  }
  const handlePriviewClick = async (params = {}) => {
    console.log('params', params)
    const res = await getReview({
      questionActiveKey,
      answerGroupKey: answerGroupKey || params.answerGroupKey,
      type: type,
      token: store.getters.getToken,
    })

    if (res.ok) {
      store.commit('setReviewList', {
        data: res.data,
      })
      router.push(
        `/list?questionActiveKey=${questionActiveKey}&isReview=true&type=${type}&answerGroupKey=${
          answerGroupKey || params.answerGroupKey
        }`
      )
    }
  }

  return {
    handlePriviewClick,
  }
}
